module.exports = __webpack_public_path__ + "static/media/Come-funziona-domiciliarità_4.e14f1930.png";